import {
  Card,
  CardContent,
  Table,
  TableBody, TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import DoneIcon from '@material-ui/icons/Done';
import LockIcon from '@material-ui/icons/Lock';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/styles';
import React from 'react';


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
  root: {},
  divider: {
    backgroundColor: '#FF9800'
  },
  table: {
    minWidth: 600
  },
  button: {
    margin: theme.spacing(0.2)
  }
}));

function PriceChangeList(FiyatData, ...rest) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  if (FiyatData.FiyatData.length === 0) {
    return <div></div>;
  }


  return (
    <Card>
      <CardContent>
        <TableContainer className={classes.container}>
          <Table className={classes.table} size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell align="left">SipVerilebilir</TableCell>
                <TableCell align="left">MalzemeStokNo</TableCell>
                <TableCell align="left">Malzeme</TableCell>
                <TableCell align="right">Fiyat</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {FiyatData.FiyatData.map((row, index) => {
                return (
                  <TableRow
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={index}

                  >
                    <TableCell align="center" className={classes.tableCell}>
                      {
                        row.SIP_VERILEBILIR === 0
                          ? <LockIcon color="error" />
                          : <DoneIcon color="success" />
                      }
                    </TableCell>
                    <TableCell align="left" className={classes.tableCell}>
                      {row.MALZEME_STOK_NO}
                    </TableCell>
                    <TableCell
                      align="left"
                      title={row.MALZEME}
                      className={classes.tableCell}
                    >
                      {row.MALZEME}
                    </TableCell>
                    <TableCell
                      align="right"
                      title={row.MALZEME}
                      className={classes.tableCell}
                    >
                      {row.BIRIM_FIYAT.toFixed(2)} ₺
                      </TableCell>
                  </TableRow>
                );
              })}

            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
}

export default PriceChangeList;
